export enum EntryAction {
  ADD = 1,
  DELETE,
  EDIT,
  RESTORE,
  STARTED_SAVING,
  COMPLETED_SAVING
}
